module.exports = __webpack_public_path__ + "assets/SAMSUNG_25_5_ikony_sft_KR_ready-03.756b8f81.svg";